import { createSlice } from "@reduxjs/toolkit";
// api
import { initExportTransactionAPI } from "src/api";
// redux
import { recursiveCheckTaskById } from "src/redux/slices/task";
import { updateDisplayTaskPopover } from "src/redux/slices/other";
// sections
import { getRequestBody } from "src/sections/transaction/utility/format-data";
// utils
import { trimObject } from "src/utils/format-object";

// ----------------------------------------------------------------------

const slice = createSlice({
    name: "transaction",
    initialState: {
        isLoading: false,
        error: null,
        // ----------------------------------
        transactionFilter: {
            source_type: "all",
            start_day: "",
            end_day: "",
            keyword: "",
            //
            page: 1,
            page_size: 100,
            total: 0
        }
    },
    reducers: {
        startLoading(state) {
            state.isLoading = true;
        },

        stopLoading(state) {
            state.isLoading = false;
        },

        hasError(state, action) {
            state.error = action.payload;
        },

        clearError(state) {
            state.error = null;
        },

        updateTransactionListFilter(state, action) {
            state.transactionFilter = {
                ...state.transactionFilter,
                ...action.payload
            };
        },

        resetTransactionListFilter(state) {
            state.transactionFilter = {
                ...state.transactionFilter,
                //
                source_type: "all",
                start_day: "",
                end_day: "",
                keyword: "",
                page: 1
            };
        }
    }
});

// Reducer
export default slice.reducer;

// Actions
export const {
    updateTransactionListFilter,
    resetTransactionListFilter,
    //
    clearError
} = slice.actions;

// ----------------------------------------------------------------------

export function getTransactionExportInit(snackbar) {
    return async (dispatch, getState) => {
        try {
            dispatch(slice.actions.startLoading());

            const _filter = getState().transaction.transactionFilter;

            const localParam = {
                ...trimObject(getRequestBody(_filter))([ "page", "page_size", "total" ]),
                //
                time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone
            };

            // const localParam = removeEmptyObjects(getRequestBody(_filter));
            // localParam.time_zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            //
            // delete localParam.page;
            // delete localParam.page_size;

            const { status, data } = await initExportTransactionAPI({ ...localParam });

            if (status === 200 && data?.code === "ok") {
                dispatch(recursiveCheckTaskById(data?.data ?? "", 0, snackbar));
                //
                setTimeout(() => dispatch(updateDisplayTaskPopover(true)), 750);

                return true;
            }

            return false;
        } catch (e) {
            dispatch(slice.actions.hasError(e));
            //
            return false;
        } finally {
            dispatch(slice.actions.stopLoading());
        }
    };
}
